function byAgeGender(ageGender) {
  if (!ageGender) return {}
  return ageGender.reduce((acc, v) => {
    const r = Object.keys(v)
      .filter(d => d !== 'gender' && d !== 'createdAt')
      .reduce((a, k) => {
        a[k] = v[k]
        return a
      }, {})
    acc[v.gender] = r
    return acc
  }, {})
}

function byCountry(country) {
  if (!country) return []
  return country.slice().sort((a, b) => b.percent - a.percent)
}

export default { byAgeGender, byCountry }
